export default "__VITE_ASSET__BjnF6UcD__"